export const ROUTES = {
  formReadCorrections: {
    parentPath: "/clinical-coding",
    slug: "form-read-corrections",
    route: "/clinical-coding/form-read-corrections",
  },
};
